import {
  clone,
  size,
  without,
  head,
  filter,
} from 'lodash'
import { ItemList } from '../orm'
import { galleryList } from './gallery'

const DEFAULT_NUM_ITEMS_PER_PAGE_FOR_GALLERY_PHOTOS = 1000

class PhotographList extends ItemList {
  getEntityKey() {
    return "photographer/photograph"
  }

  fetchGalleryPhotographs(gallery_id) {
    return async (dispatch, getState) => {
      dispatch(this.updatePaginationNumItemsPerPage(DEFAULT_NUM_ITEMS_PER_PAGE_FOR_GALLERY_PHOTOS))
      dispatch(this.updateListFilter({ gallery_id }))
      dispatch(this.fetchListIfNeeded())
    }
  }
  
  getGalleryPhotographs() {
    return this.getVisibleObjects()
  }

}

export const photographList = new PhotographList("photograph_default")

export const deleteSelectedPhotographs = ({
  selectedPhotographIds,
  showError,
  dispatch,
  setSelectedPhotographIds,
  showSuccess,
  gallery_id,
  galleryPhotographs,
}) => {
  let photograph_ids = clone(selectedPhotographIds);
  const num_photographs_to_delete = size(photograph_ids);

  const onDeleted = (json) => {
    if (json.errors) {
      showError("Error", JSON.stringify(json.errors));
      return;
    }

    photograph_ids = without(photograph_ids, json.id);
    if (size(photograph_ids) > 0) {
      deleteNext();
      return;
    }

    dispatch(photographList.fetchGalleryPhotographs(gallery_id));
    dispatch(galleryList.invalidateList());
    dispatch(galleryList.fetchListIfNeeded());
    setSelectedPhotographIds([]);
    showSuccess(
      "Updated",
      `Made ${num_photographs_to_delete} photograph${
            num_photographs_to_delete > 1 ? "s" : ""
          } unavailable for purchase`
    );
  };

  const deleteNext = () => {
    const photograph_id = head(photograph_ids);
    const photograph = filter(galleryPhotographs, (p) => p.id === photograph_id)[0];
    const values = Object.assign({}, photograph, {
      available_to_purchase: false,
    });
    dispatch(photographList.saveObject(values)).then(onDeleted);
  };

  deleteNext();
};
